module.exports = __webpack_public_path__ + "img/gxzs.b68cba44.jpg";